import css from 'styled-jsx/css';
import { common } from '../../theme/theme';

const style = css`
  .column-panel-wrapper {
    box-sizing: border-box;
    padding: 40px 16px 16px;
    background: #f1f1f1;
  }
  .column-panel-wrapper :global(.ant-checkbox-group) {
    display: flex !important;
    flex-direction: column !important;
    /* antd's group wraps by default, which turns a capped height into extra columns */
    flex-wrap: nowrap !important;
    max-height: 60vh;
    overflow-x: hidden;
    overflow-y: auto;
    overscroll-behavior: contain;
  }
  .column-panel-wrapper :global(.ant-checkbox-group-item) {
    font-size: 16px;
    margin-bottom: 8px;
    flex-shrink: 0;
  }
  // .column-panel-wrapper :global(.ant-checkbox-checked .ant-checkbox-inner) {
  //   ${common.checkbox}
  // }
  // .column-panel-wrapper
  //   :global(
  //     .ant-checkbox-group-item:hover .ant-checkbox-checked .ant-checkbox-inner
  //   ) {
  //   ${common.checkbox}
  // }
  // .column-panel-wrapper
  //   :global(.ant-checkbox-checked.ant-checkbox-disabled .ant-checkbox-inner) {
  //   ${common.checkboxDisabled}
  // }
`;

export default style;
